import i18n from "@/i18n";

export const TutorialConstant = {
    "ib-monitor": {
        pageComponent: {
            monitor: {
                step: 1,
                title: "Page Component 1/3",
                intro: "This is the section where trade summaries are presented from various perspectives, curated specifically for the chosen user.",
            },
            exposure: {
                step: 2,
                title: "Page Component 2/3",
                intro: "This is the section where the exposure chart will be generated, displaying data tailored to the selected profile.",
            },
            profile: {
                step: 3,
                title: "Page Component 3/3",
                intro: "This is the section where various profiles, each with unique sales/user parameters, can be created, edited, and removed.",
            },
        },
        profileManipulation: {
            profileName: {
                step: 4,
                title: "Profile Manipulation 1/6",
                intro: "This section shows the name of current selected profile. Default profile name cannot be modified.",
            },
            profileEdition: {
                step: 5,
                title: "Profile Manipulation 2/6",
                intro: "profile edition icons",
            },
            userSalesParam: {
                step: 6,
                title: "Profile Manipulation 3/6",
                intro: "users and sales parameter, notify auth user that only number and comma is allowed",
            },
            revertParams: {
                step: 7,
                title: "Profile Manipulation 4/6",
                intro: "revert param, if user key in param in the last step, welcome user to try and revert to empty param to test the functionality",
            },
            saveAsNew: {
                step: 8,
                title: "Profile Manipulation 5/6",
                intro: "ask user to try this function or skip it",
            },
            profileList: {
                step: 9,
                title: "Profile Manipulation 6/6",
                intro: "This is where profile list can be view and select.",
            },
        },
    },
    "home-page-intro": {
        homeTutorialIcon: {
            title: i18n.t("tutorial.homePageIntro.homeTutorialIcon.title"),
            intro: i18n.t("tutorial.homePageIntro.homeTutorialIcon.intro"),
        },
        monitorHomeTutorial: {
            title: i18n.t("tutorial.homePageIntro.monitorHomeTutorial.title"),
            intro: i18n.t("tutorial.homePageIntro.monitorHomeTutorial.intro"),
        },
        allBookHomeTutorial: {
            title: i18n.t("tutorial.homePageIntro.allBookHomeTutorial.title"),
            intro: i18n.t("tutorial.homePageIntro.allBookHomeTutorial.intro"),
        },
        functionalTabsHomeTutorial: {
            title: i18n.t(
                "tutorial.homePageIntro.functionalTabsHomeTutorial.title"
            ),
            intro: i18n.t(
                "tutorial.homePageIntro.functionalTabsHomeTutorial.intro"
            ),
        },
        profileHomeTutorial: {
            title: i18n.t("tutorial.homePageIntro.profileHomeTutorial.title"),
            intro: i18n.t("tutorial.homePageIntro.profileHomeTutorial.intro"),
        },
        symbolSearch: {
            title: i18n.t("tutorial.homePageIntro.symbolSearch.title"),
            intro: i18n.t("tutorial.homePageIntro.symbolSearch.intro"),
        },
        "home-table": {
            title: i18n.t("tutorial.homePageIntro.home-table.title"),
            intro: i18n.t("tutorial.homePageIntro.home-table.intro"),
        },
        symbolEODDialog: {
            title: i18n.t("tutorial.homePageIntro.symbolEODDialog.title"),
            intro: i18n.t("tutorial.homePageIntro.symbolEODDialog.intro"),
        },
        monitorFunctions: {
            title: i18n.t("tutorial.homePageIntro.monitorFunctions.title"),
            intro: i18n.t("tutorial.homePageIntro.monitorFunctions.intro"),
        },
        allBookFunction: {
            title: i18n.t("tutorial.homePageIntro.allBookFunction.title"),
            intro: i18n.t("tutorial.homePageIntro.allBookFunction.intro"),
        },
    },
    homeSymbolDialog: {
        symbolTabChanging: {
            title: i18n.t("tutorial.homeSymbolDialog.symbolTabChanging.title"),
            intro: i18n.t("tutorial.homeSymbolDialog.symbolTabChanging.intro"),
        },
        symbolTabSearch: {
            title: i18n.t("tutorial.homeSymbolDialog.symbolTabSearch.title"),
            intro: i18n.t("tutorial.homeSymbolDialog.symbolTabSearch.intro"),
        },
        symbolDetailTable: {
            title: i18n.t("tutorial.homeSymbolDialog.symbolDetailTable.title"),
            intro: i18n.t("tutorial.homeSymbolDialog.symbolDetailTable.intro"),
        },
    },
    homeSymbolSnapshotDialog: {
        symbolTabTimeSelection: {
            title: i18n.t(
                "tutorial.homeSymbolSnapshotDialog.symbolTabTimeSelection.title"
            ),
            intro: i18n.t(
                "tutorial.homeSymbolSnapshotDialog.symbolTabTimeSelection.intro"
            ),
        },
        symbolTabSnapshotTable: {
            title: i18n.t(
                "tutorial.homeSymbolSnapshotDialog.symbolTabSnapshotTable.title"
            ),
            intro: i18n.t(
                "tutorial.homeSymbolSnapshotDialog.symbolTabSnapshotTable.intro"
            ),
        },
    },
    loginTradesDialog: {
        loginTradesDesc: {
            title: i18n.t("tutorial.loginTradesDialog.loginTradesDesc.title"),
            intro: i18n.t("tutorial.loginTradesDialog.loginTradesDesc.intro"),
        },
        loginTradesRefresh: {
            title: i18n.t(
                "tutorial.loginTradesDialog.loginTradesRefresh.title"
            ),
            intro: i18n.t(
                "tutorial.loginTradesDialog.loginTradesRefresh.intro"
            ),
        },
        loginTradesExpansion: {
            title: i18n.t(
                "tutorial.loginTradesDialog.loginTradesExpansion.title"
            ),
            intro: i18n.t(
                "tutorial.loginTradesDialog.loginTradesExpansion.intro"
            ),
        },
        loginTradesCalculationReference: {
            title: i18n.t(
                "tutorial.loginTradesDialog.loginTradesCalculationReference.title"
            ),
            intro: i18n.t(
                "tutorial.loginTradesDialog.loginTradesCalculationReference.intro"
            ),
        },
        loginTradesDetail: {
            title: i18n.t("tutorial.loginTradesDialog.loginTradesDetail.title"),
            intro: i18n.t("tutorial.loginTradesDialog.loginTradesDetail.intro"),
        },
    },
    loginInfoDialog: {
        loginGroupChangeHistory: {
            title: i18n.t(
                "tutorial.loginInfoDialog.loginGroupChangeHistory.title"
            ),
            intro: i18n.t(
                "tutorial.loginInfoDialog.loginGroupChangeHistory.intro"
            ),
        },
        loginStatistic: {
            title: i18n.t("tutorial.loginInfoDialog.loginStatistic.title"),
            intro: i18n.t("tutorial.loginInfoDialog.loginStatistic.intro"),
        },
    },
    alertPageIntro: {
        alertGridElement: {
            title: i18n.t("tutorial.alertPageIntro.alertGridElement.title"),
            intro: i18n.t("tutorial.alertPageIntro.alertGridElement.intro"),
        },
        alertRefresh: {
            title: i18n.t("tutorial.alertPageIntro.alertRefresh.title"),
            intro: i18n.t("tutorial.alertPageIntro.alertRefresh.intro"),
        },
        alertCalender: {
            title: i18n.t("tutorial.alertPageIntro.alertCalender.title"),
            intro: i18n.t("tutorial.alertPageIntro.alertCalender.intro"),
        },
        alertDownload: {
            title: i18n.t("tutorial.alertPageIntro.alertDownload.title"),
            intro: i18n.t("tutorial.alertPageIntro.alertDownload.intro"),
        },
        alertConfig: {
            title: i18n.t("tutorial.alertPageIntro.alertConfig.title"),
            intro: i18n.t("tutorial.alertPageIntro.alertConfig.intro"),
        },
        alertClose: {
            title: i18n.t("tutorial.alertPageIntro.alertClose.title"),
            intro: i18n.t("tutorial.alertPageIntro.alertClose.intro"),
        },
        alertBookSelection: {
            title: i18n.t("tutorial.alertPageIntro.alertBookSelection.title"),
            intro: i18n.t("tutorial.alertPageIntro.alertBookSelection.intro"),
        },
        "vue-resizable-handle": {
            title: i18n.t("tutorial.alertPageIntro.vue-resizable-handle.title"),
            intro: i18n.t("tutorial.alertPageIntro.vue-resizable-handle.intro"),
        },
        alertPeriod: {
            title: i18n.t("tutorial.alertPageIntro.alertPeriod.title"),
            intro: i18n.t("tutorial.alertPageIntro.alertPeriod.intro"),
        },
        alertColumnNumber: {
            title: i18n.t("tutorial.alertPageIntro.alertColumnNumber.title"),
            intro: i18n.t("tutorial.alertPageIntro.alertColumnNumber.intro"),
        },
        alertChangeApply: {
            title: i18n.t("tutorial.alertPageIntro.alertChangeApply.title"),
            intro: i18n.t("tutorial.alertPageIntro.alertChangeApply.intro"),
        },
        alertRevert: {
            title: i18n.t("tutorial.alertPageIntro.alertRevert.title"),
            intro: i18n.t("tutorial.alertPageIntro.alertRevert.intro"),
        },
        alertAddNewChart: {
            title: i18n.t("tutorial.alertPageIntro.alertAddNewChart.title"),
            intro: i18n.t("tutorial.alertPageIntro.alertAddNewChart.intro"),
        },
        alertSaveChange: {
            title: i18n.t("tutorial.alertPageIntro.alertSaveChange.title"),
            intro: i18n.t("tutorial.alertPageIntro.alertSaveChange.intro"),
        },
        alertPageProfile: {
            title: i18n.t("tutorial.alertPageIntro.alertPageProfile.title"),
            intro: i18n.t("tutorial.alertPageIntro.alertPageProfile.intro"),
        },
    },
    searchPageIntro: {
        searchFilter: {
            title: "Search Filter",
            intro: "This is the section where you cna customize your search preferences.\
            Default Search options are pre-defined for all users.",
        },
        moreSearchFilter: {
            title: "More Filter Options",
            intro: "After Click MORE button, more search options will be listed below.",
        },
        searchButton: {
            title: "Search Button",
            intro: "This button allows to fetch the data from database that meets your search filter.",
        },
        searchDownload: {
            title: "Search Download",
            intro: "After clicking REQUEST CSV button, a request will be sent. \
            Once the backend receive the request, a csv file will be generated and link will be sent to your email address once ready. \
            The generation may take various time depends on the data complexity, thus please bear some time for the csv file to be generated. \
            Also, you can check the status of csv file generation in DOWNLOAD REQUEST STATUS tab.",
        },
        searchTable: {
            title: "Result Data Table",
            intro: "After clicking search button, the data will be fetched. Once received, the data will be displayed in the table below.",
        },
        searchDownloadTable: {
            title: "Search Download Table",
            intro: "In this section, you will be able to check all of previous download requests. \
            Meanwhile you can check the processing status and corresponding search filter of such download requests ",
        },
        searchDownloadRefresh: {
            title: "Refresh Download Status",
            intro: "By clicking this button, a request will be sent out to check the latest update on previous download requests. \
            If there's any update, the data on the table will be changed.",
        },
    },
    lpPageIntro: {
        positionTable: {
            title: i18n.t("tutorial.lpPageIntro.positionTable.title"),
            intro: i18n.t("tutorial.lpPageIntro.positionTable.intro"),
        },
        lpChange: {
            title: i18n.t("tutorial.lpPageIntro.lpChange.title"),
            intro: i18n.t("tutorial.lpPageIntro.lpChange.intro"),
        },
        lpRefresh: {
            title: i18n.t("tutorial.lpPageIntro.lpRefresh.title"),
            intro: i18n.t("tutorial.lpPageIntro.lpRefresh.intro"),
        },
        intervalChange: {
            title: i18n.t("tutorial.lpPageIntro.intervalChange.title"),
            intro: i18n.t("tutorial.lpPageIntro.intervalChange.intro"),
        },
        accountTable: {
            title: i18n.t("tutorial.lpPageIntro.accountTable.title"),
            intro: i18n.t("tutorial.lpPageIntro.accountTable.intro"),
        },
        accountFunctions: {
            title: i18n.t("tutorial.lpPageIntro.accountFunctions.title"),
            intro: i18n.t("tutorial.lpPageIntro.accountFunctions.intro"),
        },
        positionRecTable: {
            title: i18n.t("tutorial.lpPageIntro.positionRecTable.title"),
            intro: i18n.t("tutorial.lpPageIntro.positionRecTable.intro"),
        },
        positionRecLastCheck: {
            title: i18n.t("tutorial.lpPageIntro.positionRecLastCheck.title"),
            intro: i18n.t("tutorial.lpPageIntro.positionRecLastCheck.intro"),
        },
        symbolWithBreakTable: {
            title: i18n.t("tutorial.lpPageIntro.symbolWithBreakTable.title"),
            intro: i18n.t("tutorial.lpPageIntro.symbolWithBreakTable.intro"),
        },
        symbolWithoutBreakTable: {
            title: i18n.t("tutorial.lpPageIntro.symbolWithoutBreakTable.title"),
            intro: i18n.t("tutorial.lpPageIntro.symbolWithoutBreakTable.intro"),
        },
        positionRecRefresh: {
            title: i18n.t("tutorial.lpPageIntro.positionRecRefresh.title"),
            intro: i18n.t("tutorial.lpPageIntro.positionRecRefresh.intro"),
        },
    },
};
